export const PARTNER_TABLE = 'partnerTable'



// WEBPACK FOOTER //
// ./src/modules/partner/state/search/type.js